const scoreRuleList = () => import('@/views/main/score/rule-list/rule-list.vue')
export default {
  path: '/main/score/scoreRuleList',
  name: 'scoreRuleList',
  component: scoreRuleList,
  children: []
}
